<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "user",
      fields: [
       {
        col:' col-12 col-md-12',
        key: "phone",
        label: "Номер телефона",
        type: "mask",
        mask:'+998#########'
      },
      {
        col:' col-12 col-md-12',
        key: "name",
        label: "Наименование",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "password",
        label: "Пароль",
        type: "field",
        textType: "text",
      },
             {
                col:' col-12',
                key: "role",
                label: "Роль пользователя",
                type: "select",
                modal:'role',
                selectKey: "title",

              },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_user",
      itemLink: "users",
      setLink: "users",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "role",
          title: "Роль",
          checkbox: false,
          control: false,
          object: "title",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
